module.exports = __webpack_public_path__ + "img/public/TrustIcons/Google.svg?7fbaf6ec";